<template>
  <Modal :active.sync="isOpen" title="Alteração de Preço" @close="closeModal">
    <div class="price-change-content">
      <vs-alert color="warning" icon="warning" class="mb-4">
        <strong>O valor da cotação foi alterado.</strong>
      </vs-alert>

      <div class="price-info">
        <p class="old-price">
          <strong>Valor anterior:</strong>
          <span class="old-value"> {{ formatCurrency(oldPrice) }}</span>
        </p>
        <p class="new-price">
          <strong>Novo valor:</strong>
          <span class="new-value"> {{ formatCurrency(newPrice) }}</span>
        </p>
      </div>

      <p class="confirmation-text">Deseja continuar com o novo preço?</p>
    </div>

    <div class="modal-actions">
      <vs-button @click="editCoverages" color="warning" outline class="font-bold">
        Voltar
      </vs-button>
      <vs-button @click="confirmPriceChange" color="success" class="font-bold">
        Continuar
      </vs-button>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../components/Modal.vue";

export default {
  name: "ModalPriceChange",
  components: { Modal },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    oldPrice: {
      type: Number,
      required: true,
    },
    newPrice: {
      type: Number,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:isOpen", false);
    },
    confirmPriceChange() {
      this.$emit("confirm");
    },
    editCoverages() {
      this.$emit("edit");
    },
    formatCurrency(value) {
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
  },
};
</script>

<style scoped>
.price-change-content {
  text-align: center;
  padding: 20px;
}

.price-info {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.old-price, .new-price {
  font-size: 1.2rem;
  margin: 8px 0;
}

.old-value {
  color: #dc3545;
  font-weight: bold;
}

.new-value {
  color: #28a745;
  font-weight: bold;
}

.confirmation-text {
  font-size: 1.1rem;
  margin: 15px 0;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  padding: 15px;
}
</style>
